import { render, staticRenderFns } from "./DicButton.vue?vue&type=template&id=f60e8ae4&scoped=true"
import script from "./DicButton.vue?vue&type=script&lang=js"
export * from "./DicButton.vue?vue&type=script&lang=js"
import style0 from "./DicButton.vue?vue&type=style&index=0&id=f60e8ae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e8ae4",
  null
  
)

export default component.exports